import api from '../axios';

export const GET_EVENT = 'GET_EVENT'

export const getEvent = (id) => (dispatch) => {
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    };
    return api.get(`/events?slug=${id}`, options)
        .then((response) => {
            dispatch({ type: GET_EVENT, payload: response.data.data})
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}
